import React, {useRef, useState, useEffect} from 'react'
import '../Dashboard.css';
import Sidebar from '../Sidebar/Sidebar';

import { Editor } from '@tinymce/tinymce-react';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { GetSingleNews, ModifyNews } from '../../Services/News/News';
import toast, { Toaster } from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Services/Includes/backend.config';

const EditNews = () => {

    const editorRef = useRef(null);
    const [title, setTitle] = useState('');
    const [initValue, setInitValue] = useState('');
    const [labels, setLabels] = useState('');
    const [lang, setLang] = useState('hu');


    const Submit = (e) => {
        e.preventDefault();
        if(!title) {
            toast.error('A cím nem maradhat üres!')
            return;
        }

        toast.promise(
            ModifyNews(title, editorRef.current?.getContent(), id, labels, lang),
            {
                loading: 'Loading',
                success: (data) =>  (data === 'OK' ? `Hír módosítva.` : `Nem sikerült módosítani.`),
                error: (err) => `Nem sikerült a hír szerkesztése: ${err.toString()}`,
            },
            {
                duration: 4000
            }
        );
      

    };

    const {id} = useParams();

    useEffect(() => {
        GetSingleNews(id).then((e) => {
            console.log(e);
            setTitle(e[0]?.title);
            setInitValue(e[0]?.content);
            setLabels(e[0]?.keywords)
        })
        return () => {
            setTitle('');
            setInitValue('');
            setLabels('');
        }
    }, [id])


    return (
        <div className='dashboard__page'>
            
            <Sidebar />
            <div className="dashboard__content" id="home">
            <Toaster />
                <h1>Hírek szerkesztése</h1>
                <div className="create__news">
                    <div>
                    
                    
                    <div className="card">
                        <div className="card__head"><h3>Hír szerkesztése</h3></div>

                        <div className="card__body">
                            <form id="create-news-form">
                                <div className="input-group">
                                    <input type="text" className='form-control' placeholder='Cím' value={title} onChange={(e) => setTitle(e.target.value)} />
                                </div>
                            </form>
                            <Editor
                                onInit={(evt, editor) => editorRef.current = editor}
                                initialValue={initValue}
                                apiKey='em5jpi5sf02sb0fa7qcqtpi4meikooepovwv0jdcpyd94lon'
                                init={{language:"hu_HU", height: 500, entity_encoding: 'raw', 
                                    plugins: 'fullscreen wordcount autosave autoresize hr table emoticons preview image imagetools',
                                    toolbar:    'insertfile undo redo | formatselect | ' +
                                                'bold italic backcolor hr | alignleft aligncenter ' +
                                                'alignright alignjustify | table | bullist numlist outdent indent | ' +
                                                'removeformat | help | preview image',
                                    file_picker_types: "file image media",
                                    
                                    images_upload_handler: async function(
                                        blobInfo,
                                        success,
                                        failure
                                        ) {
                                            let imageFile = new FormData();
                                            imageFile.append("files[]", blobInfo.blob());

                                            axios.post(API_URL + `/functions/fileupload.php`, imageFile, {headers: {
                                                'Content-Type': 'multipart/form-data'
                                            }}).then((data) => success(data.data.response));
                                        }
                                }}

                            />
                            
                        </div>
                    </div>
                    <div className="card">
                            <div className="card__head"><h3>Beállítások</h3></div>
                            <div className="card__body">
                                Nyelv
                                <select id="nyelv" className="select mb-4 form-sm" value={lang} onChange={(e) => setLang(e.target.value)}>
                                    <option value="hu">Magyar</option>
                                    <option value="en">Angol</option>
                                    <option value="sk">Szlovák</option>
                                </select>
                                Leírás 
                                <textarea className="form-control form-sm" placeholder='Valamilyen leírás' value={labels} onChange={(e) => setLabels(e.target.value)} />
                                <small>Ez a leírás megosztások esetén jelenik meg (pl.: Facebookon).</small>
                                <div className="mb-2"></div>
                            </div>
                    </div>
                    </div>
                    <div className="news-settings">
                        
                        <div className="card">
                            <div className="card__head"><h3>Közzététel</h3></div>
                            <div className="card__body">
                                <button className="btn bg-success" onClick={Submit}><IoCheckmarkCircle className='btn-icon' /> Mentés</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </div>
    )
}

export default EditNews
